/* eslint-disable no-useless-escape */
/**
 * @todo
 * Waiting for next stage to implement this feature.
 
*/
import {
  Formatter,
  useCMSBlogs,
  useCMSCollectionBlog,
} from "@with-nx/hooks-n-helpers";
import {
  DesignedButton,
  DesignedPagination,
  Rule,
} from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import {
  CatalogLayout,
  CatalogLayoutWait,
  GridBlog,
  GridStepScroller,
  ReusableCheckboxSidebar,
  ReusableCheckboxSidebarItem,
  ReusableContainerSlantedCallToAction,
} from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { BsFacebook } from "react-icons/bs";
import { Box } from "simple-effing-primitive-layout";

export default function Page({ resolvedUrl }) {
  const [page, _page] = useState(0);
  const [ready, _ready] = useState(false);
  const [items, _items] = useState<ReusableCheckboxSidebarItem[]>([
    {
      label: "Getting Started",
      value: "Getting Started",
    },
    {
      label: "Our Partnerships",
      value: "Our Partnerships",
    },
    { label: "Pilots", value: "Pilots" },
    {
      label: "Press Release",
      value: "Press Release",
    },
    {
      label: "Product Release",
      value: "Product Release",
    },
    {
      label: "Problem? Solved!",
      value: "Problem? Solved!",
    },
    {
      label: "Technical Case Study",
      value: "Technical Case Study",
    },
    {
      label: "Workshops/Classes",
      value: "Workshops/Classes",
    },
  ]);
  const [storyTypeTags, setStoryTypeTags] = useState<string[]>([]);

  const collection = useCMSCollectionBlog();
  const _blogs = useCMSBlogs({
    page,
    per: 12,
    filter:
      storyTypeTags.length === 0
        ? { isDraft: false }
        : { storyTypeTags, isDraft: false },
  });

  const blogs =
    storyTypeTags?.length > 0 || page !== 0
      ? _blogs?.blogs || []
      : collection?.data?.blogs || [];

  useEffect(() => {
    if (ready) {
      return;
    }

    if (Formatter.gup("filter")) {
      const is = [...items];

      is.map((item, i) => {
        if (
          item.value ===
          decodeURIComponent(Formatter.gup("filter")).replace(/\+/g, " ")
        ) {
          is[i].active = true;
          setStoryTypeTags([...storyTypeTags, item.value]);
        }
      });

      _items(is);
    }

    _ready(true);
  }, [ready]);

  if (!ready) {
    return null;
  }

  return (
    <CatalogLayout
      transparentFixedNavBar
      footerNoAngle
      title="Broadway Media - Stories"
      resolvedUrl={resolvedUrl}
    >
      <CatalogLayoutWait timeout={5000} until={[!collection.loading]}>
        <ReusableContainerSlantedCallToAction
          index="1"
          justify="center"
          gradients="blue"
          lg={24}
          md={24}
          bottom={48}
          slanted={false}
          top={96}
        >
          <ReusableSection background="transparent">
            <div className="container">
              <Rule
                parse="!hl d:block mb:36 ta:center"
                css="--blue-gradient-text"
              >
                Featured Stories
              </Rule>
              <GridStepScroller
                xs={24}
                sm={24}
                md={12}
                lg={8}
                xl={8}
                items={collection?.data?.featureds?.map((blog, b) => {
                  if (b > 2) {
                    return null;
                  }

                  return (
                    <GridBlog
                      key={blog._id}
                      date={blog.date}
                      description={blog.description}
                      image={Formatter.compressed(blog.coverImage, 256, true)}
                      title={blog.title}
                      url={`/blog/${blog.slug}`}
                      transparent={false}
                      properties={{
                        height: "100%",
                      }}
                    />
                  );
                })}
              />
            </div>
          </ReusableSection>
        </ReusableContainerSlantedCallToAction>

        {collection?.data?.groups?.length > 0 ? (
          <ReusableSection top={96} bottom={96}>
            <GridStepScroller
              xs={24}
              sm={24}
              md={12}
              items={collection?.data?.groups?.map((group, g) => (
                <Box
                  key={group._id}
                  parse="pa:32 br:10 c:?foreground h:100% d:flex fd:column j:space-between"
                  style={{
                    minHeight: 352,
                    backgroundSize: "cover",
                    backgroundPosition: "bottom right",
                    backgroundImage: `url(${Formatter.image(
                      group.coverImage
                    )})`,
                  }}
                >
                  <Box>
                    <Box css="d:flex a:center" parse="mb:16">
                      <BsFacebook
                        fill="#59687B"
                        size={16}
                        title="facebook icon"
                      />
                      <Rule
                        parse="!lt d:block ml:4"
                        style={{ textTransform: "uppercase" }}
                        color="#59687B"
                        left={4}
                      >
                        {group.groupType}
                      </Rule>
                    </Box>
                    <Rule parse="!ht d:block mb:8">{group.title}</Rule>
                    <Rule parse="!ps d:block w:70% c:#AFAFAF">
                      {group.description}
                    </Rule>
                  </Box>
                  <Box parse="mt:24">
                    <DesignedButton
                      label={group.buttonText}
                      href={group.buttonURL}
                      size="medium"
                      theme="tetriary"
                    />
                  </Box>
                </Box>
              ))}
            />
          </ReusableSection>
        ) : undefined}

        <ReusableSection background="transparent">
          <div className="container mx-auto max-w-7xl">
            <ReusableSection>
              <div className="container">
                <Rule
                  parse="!hl d:block mb:24 ta:center"
                  css="--blue-gradient-text"
                >
                  Stories from Our Community
                </Rule>
              </div>
              <Row gutter={[36, 18]}>
                <Col xs={24} sm={24} md={8} lg={6}>
                  <ReusableCheckboxSidebar
                    groups={{
                      type: {
                        label: "Story Type",
                        items,
                      },
                    }}
                    change={(groups) => {
                      setStoryTypeTags(
                        (groups["type"].items.map((item) => item.value) ||
                          []) as string[]
                      );
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={16} lg={18}>
                  <Row gutter={[36, 18]}>
                    {blogs.map((item, i) => (
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        key={item._id}
                      >
                        <GridBlog
                          date={item.date}
                          url={`/blog/${item.slug}`}
                          title={item.title}
                          description={item.description}
                          image={Formatter.compressed(
                            item.coverImage,
                            256,
                            true
                          )}
                          properties={{
                            height: "100%",
                          }}
                        />
                      </Col>
                    ))}
                  </Row>
                  {blogs.length > 0 ? (
                    <Box parse="d:flex a:center j:flex-end mt:24">
                      <DesignedPagination
                        mode="select"
                        size={_blogs.pages + 1}
                        value={_blogs.page}
                        label={(index) => index + 1}
                        press={(index) => {
                          _page(index);
                        }}
                      />
                    </Box>
                  ) : undefined}
                </Col>
              </Row>
            </ReusableSection>
          </div>
        </ReusableSection>
      </CatalogLayoutWait>
    </CatalogLayout>
  );
}

export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
